export default __webpack_public_path__ + "static/media/Marta_Voda_AHV_In_Moms_We_Trust.fbf3ecce.jpg";